export const defaultDecimalPlaces = 2;
export const defaultNumericPlaces = 0;

